<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <h4>MerchantApp Kullanıcı Düzenle</h4>
      <v-row style="margin-top: 100px;">
        <!-- <v-col cols="12" md="4">
          <h4>Ad</h4>
          <v-text-field v-model="readerAppUser.firstName" disabled required></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Soyad</h4>
          <v-text-field v-model="readerAppUser.lastName" disabled required></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>-->

        <v-col cols="12" md="4">
          <h4>Mail Adresi</h4>
          <v-text-field
            v-model="readerAppUser.email"
            disabled
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Şifre sıfırla</h4>
          <v-btn
            depressed
            color="#4d48f9"
            style="color: white;"
            @click="resetPassword()"
          >
            Şifre Sıfırla
          </v-btn>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4" v-if="isAdmin">
          <h4>Firma</h4>
          <v-select
            v-model="readerAppUser.companyId"
            :items="allCompanyList"
            @change="companyChange"
            item-text="companyName"
            item-value="id"
            label="Seçiniz"
            data-vv-name="select"
            required
          ></v-select>
        </v-col>
        <v-col cols="12" md="8" v-if="isAdmin"></v-col>

        <v-col cols="12" md="4" v-if="isAdmin">
          <h4>Mağaza/Tabela</h4>
          <v-select
            v-model="readerAppUser.venueId"
            :items="allVenues"
            item-text="venueName"
            item-value="id"
            label="Seçiniz"
            data-vv-name="select"
            required
          ></v-select>
        </v-col>
        <v-col cols="12" md="8" v-if="isAdmin"></v-col>

        <v-col cols="12" md="4">
          <h4>Rol</h4>
          <v-select
            v-model="readerAppUser.role"
            :items="roles"
            item-text="name"
            item-value="value"
            label="Seçiniz"
            data-vv-name="select"
            required
          ></v-select>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Aktif/Pasif</h4>
          <v-checkbox
            v-model="readerAppUser.active"
            color="#4d48f9"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="7">
          <v-btn
            depressed
            color="#4d48f9"
            style="text-transform: none !important; float: right; color: white;"
            @click="readerAppUserUpdate()"
            :disabled="disabledButton"
          >
            GÜNCELLE
          </v-btn>
        </v-col>
      </v-row>

      <v-dialog v-model="dialog" max-width="600">
        <v-card>
          <v-card-title class="headline">
            Lütfen alanları kontrol edin
          </v-card-title>

          <v-card-text>
            <ul>
              <li v-for="fruit in this.errorList" :key="fruit">{{ fruit }}</li>
            </ul>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- <v-row>
          
      </v-row>-->
    </v-container>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'readerAppUserDetail',
  data: () => ({
    valid: true,
    isAdmin: false,
    errorList: [],
    dialog: false,
    roles: [
      {
        name: 'Mağaza Sahibi',
        value: 'ReaderUserVenueOwner',
      },
      {
        name: 'Barista',
        value: 'ReaderUser',
      },
    ],
    disabledButton: true,
  }),
  watch: {
    'readerAppUser.role': function (val) {
      this.disabledButton =
        !val || !this.readerAppUser.companyId || !this.readerAppUser.venueId
    },
    'readerAppUser.companyId': function (val) {
      this.disabledButton =
        !val || !this.readerAppUser.role || !this.readerAppUser.venueId
    },
    'readerAppUser.venueId': function (val) {
      this.disabledButton =
        !val || !this.readerAppUser.role || !this.readerAppUser.companyId
    },
  },
  computed: mapGetters(['readerAppUser', 'allVenues', 'allCompanyList']),
  created() {
    let user = {
      id: this.$route.params.id,
    }
    this.getReaderAppUser(user.id).then((userResponse) => {
      this.disabledButton = !(
        userResponse.role &&
        userResponse.companyId &&
        userResponse.venueId
      )
      this.getCompanieList().then(() => {
        this.getVenues(userResponse.companyId).then(() => {})
      })
    })

    this.userRoles = JSON.parse(localStorage.getItem('userRoles'))

    if (this.userRoles.includes('PanelUser')) {
      this.isAdmin = true
      console.log('admin', this.isAdmin)
    }
  },
  methods: {
    ...mapActions([
      'getReaderAppUser',
      'putUpdateReaderAppUser',
      'getVenues',
      'getCompanieList',
      'getResetPasswordReaderAppUser',
    ]),
    resetPassword() {
      console.log('reset')
      let user = {
        id: this.$route.params.id,
      }
      this.getResetPasswordReaderAppUser({
        email: this.readerAppUser.email,
      })
        .then((data) => {
          if (data.processStatus == 'Success') {
            alert('Şifre mail adresine gönderilmiştir')
          }
        })
        .catch((err) => {
          if (err.response.data) {
            const errorKey = err.response.data.friendlyMessage.message
            if (errorKey == 'reader_user_is_pending_approval') {
              alert('Onay bekleyen kullanıcının şifresi sıfırlanamaz.')
            } else if (errorKey == 'required_fields_missing') {
              alert('Zorunlu alanları kontrol ediniz.')
            } else if (errorKey == 'venue_not_found') {
              alert('Mağaza bulunamadı.')
            } else if (errorKey == 'company_not_found') {
              alert('İş yeri bulunamadı.')
            } else if (errorKey == 'reader_user_already_registered') {
              alert('Aynı email adresi ile kayıtlı kullanıcı bulunmaktadır.')
            } else {
              alert('Bir hata oluştu')
            }
          } else {
            alert('Bir hata oluştu')
          }
        })
    },
    routeReaderAppUsers() {
      this.$router.push('/dashboard/users/readerAppUsers')
    },
    companyChange(companyId) {
      this.getVenues(companyId).then((data) => {
        this.readerAppUser.venueId = data[0].id
      })
    },
    readerAppUserUpdate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true
        this.putUpdateReaderAppUser(this.readerAppUser)
          .then(() => {
            this.routeReaderAppUsers()
          })
          .catch(() => {
            alert('Bir hata oluştu')
          })
      } else {
        const errors = Array.from(
          document.getElementsByClassName('v-messages__message'),
        ).map((el) => el.innerHTML)
        this.errorList = errors
        this.dialog = true
      }
    },
  },
}
</script>
